<script setup lang="ts">
import Stroke from 'ol/style/Stroke'
import Fill from 'ol/style/Fill'
import Style from 'ol/style/Style'
import chroma from 'chroma-js'
import BaseLayerVector from '@/components/map/base-layers/BaseLayerVector.vue'

const vectorStyle = new Style({
  stroke: new Stroke({
    color: 'purple',
    width: 1,
  }),
})

const { features, isReady } = useGeojsonDataFetch('electricity-network-owners', {
  generalStyle: vectorStyle,
})

const uniqueFeatures = computed(() => {
  if (!features.value) return []
  return features.value
    .filter(
      (feature, i, a) => a.findIndex((f) => f.get('company') === feature.get('company')) === i
    )
    .sort((a, b) => a.get('company').localeCompare(b.get('company')))
    .map((feature, i) => ({ company: feature.get('company'), index: i }))
})

const styleArray = computed(() => {
  const styles: Style[] = []
  // const colorScale = chroma.scale(['4F8C9D','FCD107','0CC0AA','BDE267','F5744B','074D65','31A62E','E29C63','A1DEF0','69EF7B','753502'])
  const colorScale = chroma
    .cubehelix()
    .start(90)
    .rotations(1)
    .gamma(0.8)
    .lightness([0, 0.3])
    .scale()
    .domain([0, 1])
  uniqueFeatures.value.forEach((feature, i) => {
    const color = colorScale(feature.index / uniqueFeatures.value.length)
      // .darken(Math.sin(feature.index))
      .alpha(0.5)
      .hex()
    // const color = chroma.random().alpha(0.5).hex()
    const strokeWidth = 1

    const vectorStyle = new Style({
      fill: new Fill({
        color,
      }),
      stroke: new Stroke({
        width: strokeWidth,
        color,
      }),
    })

    styles.push(vectorStyle)
  })

  return styles
})

watch(features, () => {
  parseFeatures()
})
if (features.value.length) {
  parseFeatures()
}


function parseFeatures() {
  if (!features.value.length) return
  features.value.forEach((feature) => {
    const styleIndex = uniqueFeatures.value.findIndex((f) => f.company === feature.get('company'))
    const style = styleArray.value[styleIndex]
    const color = style.getFill()?.getColor()

    feature.set('label', `${feature.get('company')} | ${feature.get('koncession')}`)
    feature.set('color', color)
    feature.set('link', `https://${feature.get('website')}`)
    feature.set('type', 'electricityGridOwner')
    // feature.set('overlayType', 'mouse')
    feature.setStyle(style)
    feature.changed()
  })
  // featuresAreReady.value = true
}
</script>

<template>
  <BaseLayerVector v-if="isReady" :features="features" />
</template>
